/*
 * @Author: your name
 * @Date: 2022-01-09 17:46:38
 * @LastEditTime: 2022-04-09 17:48:24
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\utils\alert-service.js
 */


const defaultTip = "提示信息";
const defaultConfirmContent = "确认操作吗？";
const defaultLoading = "加载中..."

import { Notify, Dialog, Toast  } from 'vant';
/**
 * 加载对象
 */
var loadingToast = null
export default {
    
    /**
     * alert弹出框
     */
    alert(message = defaultTip) {
        Dialog.alert({
            message: message
        })
    },

    /**
     * 打开确认取消弹出框
     */
    confirm(message = defaultConfirmContent) {    
        return new Promise((resolve)=> {    
            Dialog.confirm({
                message: message,
                confirmButtonColor: "#ff8100"
            })
            .then(() => {
                resolve(true)
            })
            .catch(() => {
                resolve(false)
            });
        })
    },

    /**
    * Toast提示
    */
    toast(message = defaultTip, type = '', position = 'middle') {
        if(type == 'success') {
            Toast.success({
                message: message,
                icon: 'passed'
            })
        }
        else if(type == 'fail') {
            Toast.fail({
                message: message,
                icon: 'close'
            })
        }else{
            Toast({
                message: message,
                position: position,
            })
        }
    },

    /**
     * 消息通知
     * @param {*} message 
     * @param {*} type 
     */
    notify(message = defaultTip, type = 'success') {
        Notify({
            message: message,
            type: type
        })
    },

    /**
     * loading加载，需要调用closeLoading()手动关闭
     */
    loading(message = defaultLoading) {
        loadingToast = Toast.loading({
            message: message,
            forbidClick: true,
            loadingType: 'spinner',
        });
    },

    /**
     * 加载关闭
     */
    loadingClose() {
        if(loadingToast) {
            loadingToast.clear()
        }
        loadingToast = null 
    }

}